export default "__VITE_PUBLIC_ASSET__1fe64346__"